(() => {
  if (window.NappiMoney) return;
  const TEMOIN_CENTIMES = 123456700;
  const DECOUPE = /^(\D*?)(\d[\d.,   ]*\d|\d)(\D*)$/;
  function formater(cents, g, { sansDecimales = false } = {}) {
    const signe = cents < 0 ? "-" : "";
    const abs = Math.abs(Math.round(cents));
    const entier = String(Math.floor(abs / 100));
    const groupe = g.sepMille ? entier.replace(/\B(?=(\d{3})+(?!\d))/g, g.sepMille) : entier;
    const centimes = String(abs % 100).padStart(2, "0");
    const chiffres = sansDecimales || !g.sepDec ? groupe : `${groupe}${g.sepDec}${centimes}`;
    return `${signe}${g.avant}${chiffres}${g.apres}`;
  }
  function gabarit(temoin) {
    const texte = String(temoin || "").trim();
    const m = texte.match(DECOUPE);
    if (!m) return null;
    const [, avant, nombre, apres] = m;
    const dec = /[.,](\d{2})$/.test(nombre);
    const sepDec = dec ? nombre[nombre.length - 3] : "";
    const entier = dec ? nombre.slice(0, -3) : nombre;
    const sepMille = (entier.match(/[^\d]/) || [""])[0];
    const g = { avant, apres, sepDec, sepMille };
    return formater(TEMOIN_CENTIMES, g) === texte ? g : null;
  }
  function seuil({ seuilBoutique, devisePanier, deviseBoutique }) {
    const base = Number(seuilBoutique);
    if (!Number.isFinite(base) || base <= 0) return null;
    if (devisePanier && devisePanier === deviseBoutique) return base;
    const devise = window.Shopify?.currency;
    if (!devise || devisePanier && devise.active && devise.active !== devisePanier) return null;
    const taux = Number(devise.rate);
    return Number.isFinite(taux) && taux > 0 ? Math.round(base * taux) : null;
  }
  window.NappiMoney = { gabarit, formater, seuil };
})();
